import { HEALTH_URL } from 'framework/enums/cacheEnum'
import { onUnmounted } from 'vue'
import { bestLineOptions } from '@admin/enums/pageEnum'
const bestHealthUrl = ref<string>('')
let intervalId: number | null = null

export default function () {
  const getLocation = () => {
    return new Promise((resolve) => {
      fetch('https://get.geojs.io/v1/ip/geo.json')
        .then((res) => res.json())
        .then((data) => {
          resolve(data.country_code)
        })
        .catch(() => {
          resolve('CN')
        })
    })
  }

  const loopFindBestLine = async () => {
    const location = await getLocation()
    const bestUrl = location == 'CN' ? bestLineOptions[0].value : bestLineOptions[1].value
    if (bestUrl) {
      localStorage.setItem(HEALTH_URL, bestUrl as string)
      bestHealthUrl.value = bestUrl
    }
  }

  //开始定时
  const startPolling = (immediately = true, isLoop = false) => {
    immediately && loopFindBestLine() // 立即执行一次
    isLoop && (intervalId = window.setInterval(loopFindBestLine, 10000)) // 每30秒执行一次,默认不轮询
  }

  //停止定时器
  const stopPolling = () => {
    if (intervalId) {
      clearInterval(intervalId)
      intervalId = null
    }
  }

  onUnmounted(() => {
    stopPolling()
  })

  return {
    bestHealthUrl,
    startPolling,
  }
}
